import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CircleAlert, Info } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { designRoles } from '../common/designRoles';

/**
 * A quiet line with a mark: what to do next (info), or what went wrong
 * (danger, announced to screen readers).
 */
export const NoticeLine = memo(
  ({ text, tone = 'info' }: { text: string; tone?: 'info' | 'danger' }) => {
    const { rpx } = useResponsiveContext();
    const color =
      tone === 'danger' ? designRoles.statusDanger : designRoles.textSecondary;
    const Mark = tone === 'danger' ? CircleAlert : Info;
    return (
      <View
        accessibilityRole={tone === 'danger' ? 'alert' : undefined}
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          gap: rpx(6),
          marginTop: rpx(14),
        }}
      >
        <Mark size={rpx(14)} color={color} style={{ marginTop: rpx(3) }} />
        <Typography.Text
          size={rpx(13)}
          lineHeight={rpx(19)}
          color={color}
          style={{ flexShrink: 1 }}
        >
          {text}
        </Typography.Text>
      </View>
    );
  },
);
